import axios from 'axios'
import config from '@/config'

const API_URL = config.API_URL

export default {
  state: {
    mail_message: null,
    mail_kod: null,
    tel_message: null,
    tel_kod: null
  },
  mutations: {
    sendDataToMailAction: (state, response) => state.mail_message = response,
    checkMailKodAction: (state, response) => state.mail_kod = response,

    sendDataToTellAction: (state, response) => state.tel_message = response,
    checkTelKodAction: (state, response) => state.tel_kod = response,
  },
  actions: {
    async sendSessageToMail(ctx, MESSAGE){
      await axios.post(
        `${API_URL}/api/rest/receipt/confirmation_mail_send_email`,
        MESSAGE,
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          }
        },
        
      ).then((response) => {
        ctx.commit('sendDataToMailAction', response.data.msg)
      })
    },

    async checkMessage(ctx, kod){
      await axios.post(
        `${API_URL}/api/rest/receipt/confirmation_mail_send_kod`,
        kod,
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          }
        },
        
      ).then((response) => {
        ctx.commit('checkMailKodAction', response.data.msg)
      })
    },
    async sendSessageToTel(ctx, MESSAGE){
      await axios.post(
        `${API_URL}/api/rest/receipt/confirmation_tel_send_sms`,
        MESSAGE,
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          }
        },
        
      ).then((response) => {
        ctx.commit('sendDataToTellAction', response.data.msg)
      })
    },
    async checkMessageFromPhone(ctx, kod){
      await axios.post(
        `${API_URL}/api/rest/receipt/confirmation_tel_send_kod`,
        kod,
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          }
        },
        
      ).then((response) => {
        ctx.commit('checkTelKodAction', response.data.msg)
      })
    },
  },
  getters:{
    mail_message: s => s.mail_message,
    mail_kod: s => s.mail_kod,
    tel_message: s => s.tel_message,
    tel_kod: s => s.tel_kod,
  },
}